import { api } from "@/lib/api";

export async function listProfileTemplates() {
  const { data } = await api.get("/profile-templates");
  return data.data;
}

export async function listProjectProfiles(projectId) {
  const { data } = await api.get(`/projects/${projectId}/contributor-profiles`);
  return data.data;
}

export async function createProfile(projectId, payload) {
  const { data } = await api.post(
    `/projects/${projectId}/contributor-profiles`,
    payload
  );
  return data.data;
}

export async function updateProfile(profileId, patch) {
  const { data } = await api.patch(
    `/contributor-profiles/${profileId}`,
    patch
  );
  return data.data;
}

export async function deleteProfile(profileId) {
  const { data } = await api.delete(`/contributor-profiles/${profileId}`);
  return data;
}

export async function getProject(projectId) {
  // Fetch project metadata from the projects list (simple client-side filter)
  const { data } = await api.get("/projects");
  return (data.data || []).find((p) => p.id === projectId) || null;
}

export async function listProjectDocuments(projectId) {
  const { data } = await api.get(`/projects/${projectId}/documents`);
  return data.data;
}

export async function runAnalysis(projectId, payload) {
  const { data } = await api.post(`/projects/${projectId}/analyses`, payload, {
    timeout: 60000,
  });
  return data.data;
}

export async function listAnalyses(projectId) {
  const { data } = await api.get(`/projects/${projectId}/analyses`);
  return data.data;
}

export const EMPTY_PROFILE = {
  name: "",
  template_key: "custom",
  monthly_salary: 0,
  work_days: 30,
  ir_rate: 0,
  social_rate: 0,
  consumption: 0,
  vat_rate: 0,
  other_taxes: 0,
  active_years: 40,
};
